//      
import {parsePath} from "react-router";

                                                                                            

// The app is embedded into third-party pages and must not touch their URL, so routing stays in memory.
// Navigation is synchronous (as with history v4), so a push and a store update from the same event
// render together. Reducers and mapDispatchToProps navigate through this module, outside of React.
const createInMemoryHistory = () => {
	const listeners = new Set();
	let keyCounter = 0;
	let location           = {pathname: "/", search: "", hash: "", state: null, key: "default"};

	const navigate = (to                                                              , state       ) => {
		const path = typeof to === "string" ? parsePath(to) : to;
		location = {pathname: "/", search: "", hash: "", ...path, state: state ?? null, key: String(++keyCounter)};
		listeners.forEach(listener => listener());
	};

	return {
		get location()           {
			return location;
		},
		push: navigate,
		replace: navigate,
		go: () => {},
		createHref: (to                                                              ) =>
			typeof to === "string" ? to : (to.pathname || "") + (to.search || "") + (to.hash || ""),
		listen: (listener            ) => {
			listeners.add(listener);
			return () => listeners.delete(listener);
		}
	};
};

export const customHistory = createInMemoryHistory();
